// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/chevron-down.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function ChevronDownIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M13.5576 4.55713C13.8015 4.3132 14.1983 4.31349 14.4424 4.55713C14.6865 4.80121 14.6865 5.19782 14.4424 5.44189L8.86914 11.0151C8.63874 11.2455 8.32582 11.3745 8 11.3745C7.67433 11.3744 7.36115 11.2454 7.13086 11.0151L1.55762 5.44189C1.31398 5.19778 1.31369 4.80106 1.55762 4.55713C1.80155 4.3132 2.19827 4.31349 2.44238 4.55713L7.43431 9.54906C7.63232 9.74707 7.73133 9.84607 7.84549 9.88317C7.94591 9.9158 8.05409 9.9158 8.15451 9.88317C8.26867 9.84607 8.36768 9.74707 8.56569 9.54906L13.5576 4.55713Z"
				fill="currentColor"
			/>
		</IconBase>
	);
}
